import React from 'react';
import LegacyVaultHero from '../../components/sections/legacy-vault/LegacyVaultHero';
import LegacyVaultValueProposition from '../../components/sections/legacy-vault/LegacyVaultValueProposition';
import LegacyVaultProductShowcase from '../../components/sections/legacy-vault/LegacyVaultProductShowcase';
import LegacyVaultTestimonial from '../../components/sections/legacy-vault/LegacyVaultTestimonial';
import LegacyVaultHowItWorks from '../../components/sections/legacy-vault/LegacyVaultHowItWorks';
import LegacyVaultFAQ from '../../components/sections/legacy-vault/LegacyVaultFAQ';
import LegacyVaultPricing from '../../components/sections/legacy-vault/LegacyVaultPricing';
import LegacyVaultTrustBuilders from '../../components/sections/legacy-vault/LegacyVaultTrustBuilders';

const LegacyVault: React.FC = () => {
    return (
        <main className="min-h-screen overflow-x-hidden legacy-vault-no-scrollbar">
            <LegacyVaultHero />
            <LegacyVaultValueProposition />
            <LegacyVaultProductShowcase />
            <LegacyVaultTestimonial />
            <LegacyVaultHowItWorks />
            <LegacyVaultFAQ />
            <LegacyVaultPricing />
            <LegacyVaultTrustBuilders />
        </main>
    );
};

export default LegacyVault;
